import { APP_NAME, APP_VERSION } from '@/constants'

export function Footer() {
  return (
    <footer className="flex h-10 shrink-0 items-center justify-between border-t border-border bg-card px-4 text-xs text-muted-foreground lg:px-6">
      <span>
        © {new Date().getFullYear()} {APP_NAME}
      </span>
      <span className="flex items-center gap-2">
        <span>{new Date().toLocaleDateString()}</span>
        <span>v{APP_VERSION}</span>
      </span>
    </footer>
  )
}
